module.exports = __webpack_public_path__ + "static/media/box.40fb5cfe.gif";